<template>
  <div>
    <digital-event-preloader v-if="loading" type="container" :active="loading" />
    <ColumnWiseMasonryLayout v-else :nodes="newFirstPosts" :total-count="posts.length">
      <template #default="{ node }">
        <photo-wall-card
          :item="node"
          :edit="canEdit"
          :key="node.uuid"
          :myPosts="isMyPosts"
          @openGallery="openGallery(node.uuid)"
        ></photo-wall-card>
      </template>
      <template #empty>
        <div class="h4 text-center tab-to-center">
          <span>Welcome to the Photo Wall</span><br />
          <span>Take a photo or upload an image</span>
          <div class="tab-post-image">
            <button id="ev-post-image-button" class="post-image" @click="openModal()">Post image</button>
          </div>
        </div>
      </template>
      <photo-wall-modal></photo-wall-modal>
    </ColumnWiseMasonryLayout>
    <show-more v-if="displayShowMore" @showMore="onShowMore()"></show-more>
    <photo-wall-image-viewer v-if="posts" :posts="oldFirstPosts"></photo-wall-image-viewer>
  </div>
</template>

<script>
import PhotoWallCard from "./PhotoWallCard.vue";
import ShowMore from "./ShowMore.vue";
import PhotoWallImageViewer from "./PhotoWallImageViewer.vue";
import Preloader from "@/components/DigitalEvent/common/Preloader";
import ColumnWiseMasonryLayout from "@/modules/core/layouts/ColumnWiseLayout";
import PhotoWallModal from "./PhotoWallModal";
import { debounce } from "@/helpers/helpers";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "PhotoWallTab",
  props: {
    isMyPosts: {
      type: Boolean,
      default: false
    },
    cols: Object
  },
  data() {
    return {
      limit: null,
      loading: true,
      windowWidth: 0
    };
  },
  components: {
    "photo-wall-card": PhotoWallCard,
    "show-more": ShowMore,
    "digital-event-preloader": Preloader,
    "photo-wall-modal": PhotoWallModal,
    "photo-wall-image-viewer": PhotoWallImageViewer,
    ColumnWiseMasonryLayout
  },
  computed: {
    ...mapState({
      photoCardsLimit: state => state.event.config.defaultPhotoWallConfig.photoCardsLimit,
      allPosts: state => state.photoWall.posts,
      totalPostsCount: state => state.photoWall.totalPostsCount
    }),
    ...mapGetters({
      isAdmin: "users/isAdmin",
      user: "users/currentUser"
    }),
    posts() {
      return this.isMyPosts ? this.myPosts : this.allPosts;
    },
    myPosts() {
      return this.allPosts.filter(post => post.userUuid === this.user.userUUID);
    },
    postsLength() {
      return this.posts.length;
    },
    newFirstPosts() {
      if (!this.posts) return [];

      return [...this.posts].sort(function(a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
    },
    oldFirstPosts() {
      if (!this.posts) return [];
      return [...this.posts].sort(function(a, b) {
        return new Date(a.createdAt) - new Date(b.createdAt);
      });
    },
    displayShowMore() {
      return this.totalPostsCount > this.limit && this.postsLength >= this.limit;
    },
    canEdit() {
      return this.isAdmin || this.isMyPosts;
    }
  },
  methods: {
    ...mapActions("photoWall", {
      getGalleryPosts: "getGalleryPosts",
      getMyGalleryPosts: "getMyGalleryPosts"
    }),
    openModal() {
      this.$modal.show("photo-wall-modal");
    },
    async getPosts(limit) {
      this.isMyPosts ? await this.getMyGalleryPosts(limit) : await this.getGalleryPosts(limit);
    },
    openGallery(postUUID) {
      const viewer = window.document.querySelector("#viewer").$viewer;
      const index = this.oldFirstPosts.findIndex(post => post.uuid === postUUID);
      viewer.view(index);
    },
    async onShowMore() {
      this.limit += this.photoCardsLimit;
      await this.getPosts(this.limit);
    }
  },
  watch: {
    postsLength: debounce(function() {
      this.getPosts(this.limit);
    }, 2000)
  },
  async created() {
    this.limit = this.photoCardsLimit;
    await this.getPosts(this.limit);
    this.loading = false;
  }
};
</script>
